import { useOktaAuth } from '@okta/okta-react'
import React, { useEffect, useState } from 'react'
import SurveyPage from './SurveyPage';
import { getSurveyResponse, getSurveyById, getSurveyLiterals, getAvailableLanguages } from '../services/survey.service';
import { useDispatch } from 'react-redux';
import { setSurveyResponse, updateUserInfo } from '../redux/action/surveyAction';
import { getCampaigsByRn } from '../services/campaign.service';
import { setCampaign } from '../redux/action/campaignAction'
import { Redirect } from 'react-router-dom';
import { SCBM_USER_TYPE, SCBM_STATES_CAMPAIGN, CTPAT, CRS_REQUEST_STATUS_OBJ,COC,SCF, LHR, AEU, CRS_SURVEY_TEMPLATES, CODE_SURVEY_LANGUAGE } from '../utils/surveyLiterals'
import { useUserInfo } from '../providers/userProvider'
import queryString from 'query-string'
import { SCBM_CODE } from '../utils/surveyLiterals'
import { updateGenResponse } from '../redux/action/genericSurveyAction'
import { ERR_DESC_REQUEST_NUMBER, ERR_DESC_SURVEY_CODE, ERR_TITLE_REQUEST_NUMBER, ERR_TITLE_SURVEY_CODE } from '../utils/errorLiterals';
import { useLocation } from 'react-router'
import { getCountry } from '../services/external.service';

function validationRules(respCampaign, userInfo) {
    let error;
    if (respCampaign) {
        if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
            //it is normal user, we have to validate that the current user has the supplier
            if (!userInfo.suppliers || userInfo.suppliers.length <= 0
                || !userInfo.suppliers.includes(respCampaign.assignments[0].supplierNumber)) {
                error = 'No suppliers assigned';
            }//else everything is OK
        }//else Read only for the deere employee
    } else {//The assignment does not exist
        error = 'No campaing found';
    }
    return error;
}

function isValidRN(rn) {
    return rn && rn.length <= 19 && !isNaN(rn) && Number.isInteger(parseFloat(rn));//Size in DB
}

function sentToReview(campaignAssigned, survey) {
    if(survey.code === COC){ // In COC we are supposed to allow the survey edit even after Assignment is complete. But not after the campaign is closed.
        return  campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED;
    }
    return campaignAssigned.assignments[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE || campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED
}

export default function Home(props) {
    const actualURL = window.location.href;
    const { authState } = useOktaAuth();
    const userInfo = useUserInfo();
    const [survey, setSurvey] = useState(undefined);
    const [containsError, setContainsError] = useState(false);
    const [campaignAssigned, setCampaignAssigned] = useState();
    const dispatch = useDispatch();
    const [surveyResponseHome, setSurveyResponseHome] = useState(undefined);
    const location = useLocation();
    const [surveyLanguages, setSurveyLanguages] = useState([]);
    const [countryList, setCountryList] = useState([]);

    let value = queryString.parse(location.search);        
    let rn = ""
    if (value.rn) {
        rn = value.rn;
    } else if (location && location.state && location.state.rn) {
        rn = location.state.rn.toString();
    }

    const [nonOktaParams] = useState({
        previous : location && location.state && location.state.previous ? location.state.previous : "",
        queryParam: location && location.state && location.state.queryParam ? location.state.queryParam : "",
        isAuthNonOkta: location && location.state && location.state.isAuthNonOkta ? location.state.isAuthNonOkta : false,
    })
    if(nonOktaParams && nonOktaParams.previous === "/surveyLogin" && !rn){
        rn = nonOktaParams.queryParam.toString();
    }
    let isAuthMethodOkta = authState && authState.isAuthenticated ? true : false;
    let nonOktaAuthFailed = !isAuthMethodOkta ? (nonOktaParams && nonOktaParams.isAuthNonOkta ? false : true) : false;
    let token = isAuthMethodOkta ? authState.accessToken.accessToken : "";

    //Remove user info from redux
    if (userInfo) {
        dispatch(updateUserInfo(userInfo));
    }
    
    useEffect(()=>{
        if (window.location.pathname === "/surveyext") props.setShowHeaderFooter(false);
    }, [])
    
    useEffect(() => {
        if ((!isAuthMethodOkta || userInfo) && rn && !campaignAssigned && isValidRN(rn)) {
            getCampaigsByRn(rn, token, isAuthMethodOkta)
                .then((res) => { 
                    let errorValidation = isAuthMethodOkta ? validationRules(res, userInfo) : false;
                    if (errorValidation) {
                        setContainsError(true)
                    } else {
                        setCampaignAssigned(res);
                        dispatch(setCampaign(res));
                    }
                }).catch(error => {
                    //Campaign not found
                    setContainsError(true)
                })
        }
    }, [userInfo, campaignAssigned]);

    useEffect(() => {
        if (!survey && campaignAssigned && !containsError) {
            getSurveyById(campaignAssigned.surveyId, token, isAuthMethodOkta)
                .then((s) => {
                    setSurvey(s);
                })
        }
    }, [survey, campaignAssigned])

    useEffect(async () => {
        if (survey && !containsError) {
            const languageList = await getAvailableLanguages(token);
            const literals = await getSurveyLiterals(survey.id, null, token, isAuthMethodOkta);
            const languages = [];
            literals.forEach((lt) => {
                if(lt.code.toLowerCase() === `${survey.code.toLowerCase()}_${CODE_SURVEY_LANGUAGE}`) {
                    const index = languageList.findIndex((item) => item.languageCd === lt.languageCd);
                    if(index > -1)  languages.push({code: lt.languageCd, name: lt.text, country_code: languageList[index].countryCode});
                }
            });
            setSurveyLanguages(languages);
        }
      }, [survey]);

    useEffect(() => {
        if (campaignAssigned && (!isAuthMethodOkta || userInfo) && survey && !containsError && !surveyResponseHome) {
            getSurveyResponse(campaignAssigned, userInfo, token, isAuthMethodOkta)
                .then((res) => {
                    if(survey.code === SCBM_CODE){
                        dispatch(setSurveyResponse(res));
                    }else{
                        dispatch(updateGenResponse({surveyCode: survey.code, surveyResponse: res}));
                    }
                    
                    setSurveyResponseHome(res);
                }).catch(error => {
                    console.log(error);
                    setSurveyResponseHome([]);
                })
        }
    }, [campaignAssigned, userInfo, dispatch, surveyResponseHome, survey]);

    useEffect(() => {
        getCountry(token, isAuthMethodOkta)
          .then((res) => {
            if (res.length > 0) {
              res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
              setCountryList(res);
            }
          })
          .catch((err) => {
            console.error(err)
          });
      }, []);
    
    if (!rn || containsError || !isValidRN(rn) || (!isAuthMethodOkta && nonOktaAuthFailed)) {
        return <Redirect
                to={{    
                pathname: '/error',
                state: {errorTitle: ERR_TITLE_REQUEST_NUMBER,
                        errorDescription: ERR_DESC_REQUEST_NUMBER, 
                        errorUrl:actualURL,
                        errorUser: userInfo? userInfo.userID : ''}
                }}
            />
    }
    if ((isAuthMethodOkta && !userInfo) || !survey) {
        return (<div>
            <h5>Loading...</h5>
        </div>)
    }
    else {
        if ((isAuthMethodOkta && !userInfo) || !campaignAssigned || !survey) {
            return (<div>
                <h5>Loading...</h5>
            </div>)
        } else {
            if (sentToReview(campaignAssigned, survey)) {
                //when its close or submitted
                return <Redirect to={{
                    pathname: isAuthMethodOkta ? '/review' : '/reviewext',
                    state: {
                        previous: '/survey',
                        survey: survey,
                        updatedByName: location && location.state ? location.state.updatedByName : '',
                        updatedTs: location && location.state ? location.state.updatedTs : '',
                        status:  campaignAssigned.assignments[0].status,
                        supplierName: campaignAssigned.assignments[0].supplierName,
                        surveyType: survey.description,
                        dueDate: campaignAssigned.dueDate,
                        campaign:campaignAssigned,
                        isAuthNonOkta : !isAuthMethodOkta
                    }
                }} />
            } else {
                switch(survey.code){
                    case CTPAT:
                        return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} />
                    case COC:
                        return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} />
                    case SCF:
                        return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} />
                    case LHR:
                        return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} />
                    case AEU:
                        return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} />
                    default:
                        break;
                }
                
                switch (survey.templateType) {
                    case CRS_SURVEY_TEMPLATES.GENERIC:
                      return <SurveyPage survey={survey} setSurvey={setSurvey} surveyLanguages={surveyLanguages} countryList={countryList}/>;
                    default:
                      return (
                        <Redirect
                          to={{
                            pathname: "/error",
                            state: { 
                                errorTitle: ERR_TITLE_SURVEY_CODE, 
                                errorDescription: ERR_DESC_SURVEY_CODE, 
                                errorUrl: actualURL, 
                                errorUser: userInfo ? userInfo.userID : "" 
                            },
                          }}
                        />
                      );
                  }
            }
        }
    }
}